export default {
    tagged: '2.2.1-3d24c8d',
    version: '2.2.1',
    revision: '3d24c8d',
};
//# sourceMappingURL=version.js.map